import React from 'react';
import './noqrView.css';
import noQrImg from './../assets/img/icon/qrCodeError.png';
import logo from '../assets/logo_text.png';
import playStoreLogo from '../assets/img/icon/playStore.png';
import appStoreLogo from '../assets/img/icon/appleStore.png';

function NoQrView({ title, message, reason }) {
    // Default messages based on error reason
    const defaultTitle = reason === 'disabled'
        ? 'QR Code Disabled'
        : reason === 'expired'
        ? 'QR Code Expired'
        : reason === 'session_expired'
        ? 'Access Expired'
        : reason === 'not_found'
        ? 'QR Code Not Available'
        : reason === 'no_card'
        ? 'Card Not Linked'
        : reason === 'data_error'
        ? 'Data Loading Error'
        : reason === 'api_error'
        ? 'Service Unavailable'
        : 'QR Code Not Available';

    const defaultMessage = reason === 'disabled'
        ? 'This QR code has been disabled by the owner. Please contact them for assistance or request a new QR code.'
        : reason === 'expired'
        ? 'This QR code has expired and is no longer valid. Please contact the owner for a new QR code.'
        : reason === 'session_expired'
        ? 'Your access window has ended. Please reload the page or rescan the QR code to access it again.'
        : reason === 'not_found'
        ? 'This QR code does not exist in our system. Please verify the QR code and try again, or contact the owner.'
        : reason === 'no_card'
        ? 'This QR code is not associated with any allergy card. Please ask the owner to link a card to this QR code in the app.'
        : reason === 'data_error'
        ? 'We could not load all the allergy information. This might be a temporary issue. Please try refreshing the page.'
        : reason === 'api_error'
        ? 'The service is not working at this moment. Please try again later.'
        : 'The QR code you scanned is invalid or does not exist. Please try scanning again or contact support.';

    return (
        <div className='noqr-page'>
            <div className='noqr-card'>
                {/* Error content */}
                <div className='noqr-content'>
                    <img className="noqr-icon" src={noQrImg} alt="QR Error" />
                    <h2 className='noqr-title'>{title || defaultTitle}</h2>
                    <p className='noqr-message'>
                        {message || defaultMessage}
                    </p>
                </div>

                {/* Footer with logo and app links */}
                <div className="noqr-footer">
                    <div className="noqr-footer-content">
                        <img src={logo} alt="Food Allergy Card" className="noqr-footer-logo" />
                        <div className="noqr-footer-download">
                            <p>Download the app</p>
                            <a href="https://play.google.com/store/apps/details?id=com.foodallergycard" target="_blank" rel="noopener noreferrer">
                                <img src={playStoreLogo} alt="Play Store" className="noqr-footer-store" />
                            </a>
                            <a href="https://apps.apple.com/app/food-allergy-card/id6448350429" target="_blank" rel="noopener noreferrer">
                                <img src={appStoreLogo} alt="App Store" className="noqr-footer-store" />
                            </a>
                        </div>
                    </div>
                    <p className="noqr-footer-copyright">&copy; {new Date().getFullYear()} Food Allergy Card. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
}

export default NoQrView;
